import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { IForm } from "UI/UI/UI/XGControls/IForm";
import { convertPurposeTypeToFormOpenType, createPageUrl } from "UI/UI/Utilities/SharedUIMethods";
import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { createElement, registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { Action } from "../Actions/Action";
import { IAction } from "../Actions/IAction";
import { DropDownMenuItem } from "./DropDownMenuItem";

const logger = LazyLoadingSectionLogger.create(LoggingSection.dropDown);

/**
 * Položka menu formuláře, která zkopíruje do schránky jeho URL.
 * Pokud má formulář nastaven purposeType, přidá se do URL jako parametr
 */
export class DropDownMenuCopyFormLinkItem extends DropDownMenuItem {
    private _linkInput: HTMLInputElement;
    private _ownerForm: IForm;

    protected override _constructor(): void {
        super._constructor();

        this.classList.add("copy-form-link-item");

        this._linkInput = createElement({ type: "input", attrs: { "type": "text" }, classes: "copy-form-link-item" }) as HTMLInputElement;

        this.insertAdjacentElement("beforeend", this._linkInput);

        this.noCloseAfterSelect = true; // Jelikož pro úspěšné zkopírování musí být input viditelný, postará se o zavření menu až samotná akce a ne automatika

        const copyAction = new Action(async (): Promise<void> => {
            const formUrl = createPageUrl({
                formCode: this.ownerForm.formName,
                formOpenType: convertPurposeTypeToFormOpenType(this.ownerForm.purposeType),
            });

            this._linkInput.classList.add("shown");
            this._linkInput.value = formUrl;
            this._linkInput.select();
            document.execCommand("copy");
            this._linkInput.classList.remove("shown");
            logger.log("Form URL has been copied to clipboard.");

            this.parent.closeAll();

            return;
        });

        this._action = copyAction;
    }

    public override get action(): IAction {
        return super.action;
    }

    public override set action(_action: IAction) {
        logger.warn("Action set operation is not supported!");
    }

    public override get locKey(): string {
        return super.locKey;
    }

    public override set locKey(v: string) {
        super.locKey = v;

        if (this.locKey) {
            Localization.addLocData(this._captionElement, this.locKey, undefined, undefined, undefined, true);
        }
    }

    public get ownerForm(): IForm {
        return this._ownerForm;
    }

    public set ownerForm(form: IForm) {
        this._ownerForm = form;
    }
}

registerCustomElement("tsc-DropDownMenuCopyFormLinkItem", DropDownMenuCopyFormLinkItem);
